import backofficeService from '../../api/backoffice'

export default {  
  getTeacherAttendancePerformance(params = {}) {
    return backofficeService.Api().get('attendance/teacher-performance-overview', { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },
  getSalesByPeriod(params) {
    return backofficeService.Api().get('sales/salesByPeriod', { params })
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
}
